import React from "react";
import Button from "../buttons/Button";
import ModalWrapper from "./ModalWrapper";

/**
 * MessageModal component displays a modal with a title, message, and an OK button.
 *
 * @param {Object} props - The component props.
 * @param {boolean} props.isOpen - Determines if the modal is open.
 * @param {string} props.title - The title to display in the modal.
 * @param {string} props.message - The message to display in the modal.
 * @param {Function} props.onClose - The function to call when the modal is closed.
 *
 * @returns {JSX.Element|null} The rendered modal component or null if not open.
 */
const MessageModal = ({
  isOpen,
  title,
  message,
  onClose,
  disableOK = false,
}) => {
  if (!isOpen) return null;

  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose}>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold text-center w-full">{title}</h2>
      </div>
      <div className="text-center">
        <p className="mb-4">{message}</p>
        <Button
          onClick={onClose}
          text="OK"
          variant={disableOK ? "disabled" : "secondary"}
          className="mt-4"
        />
      </div>
    </ModalWrapper>
  );
};

export default MessageModal;
